import { Card } from "@fpsoftware/mvp";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { TbPlus } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { NewRFQBodySchema } from "shared";
import { AddressSelect } from "@/addresses/AddressSelect";
import { Api } from "@/api.config";
import { BorrowerSelect } from "@/borrower/BorrowerSelect";
import { Button } from "@/components/Button";
import { FormGroup } from "@/components/form/FormGroup";
import { NumberInput } from "@/components/form/NumberInput";
import { TextField } from "@/components/form/TextField";
import { Container } from "@/components/grid/Container";
import { LinkGen } from "@/LinkGen";
import { AppPage } from "@/layout/AppLayout";

export const PageMortgageNew = () => {
  const navigate = useNavigate();

  const { formState, control, handleSubmit } = useForm({
    resolver: zodResolver(NewRFQBodySchema),
    reValidateMode: "onBlur",
  });

  const onSubmit = handleSubmit(async (values) => {
    const { data: ID } = await Api.MortgageNew(values);
    navigate(LinkGen.RFQ.Detail(ID));
  });

  return (
    <AppPage title="New RFQ">
      <Container>
        <form onSubmit={onSubmit}>
          <Card>
            <Card.Header>New RFQ</Card.Header>
            <Card.Body>
              <Card.Title>Customer information</Card.Title>
              <FormGroup
                label="Borrower"
                htmlFor="borrower"
                required
                error={formState.errors.borrowerID?.message}
              >
                <BorrowerSelect
                  placeholder="Search borrower..."
                  id="borrower"
                  control={control}
                  name="borrowerID"
                />
              </FormGroup>
              <FormGroup
                label="Address"
                htmlFor="address"
                required
                error={formState.errors.addressID?.message}
              >
                <AddressSelect
                  placeholder="Search address..."
                  id="address"
                  control={control}
                  name="addressID"
                />
              </FormGroup>
            </Card.Body>
            <Card.Body>
              <Card.Title>Current mortgage details</Card.Title>
              <NumberInput
                label="Outstanding balance"
                required
                placeholder="Outstanding balance"
                id="balance"
                control={control}
                name="balance"
              />
              <NumberInput
                label="Interest rate"
                required
                placeholder="Interest rate"
                control={control}
                dp={4}
                name="interestRate"
              />
              <NumberInput
                control={control}
                name="escrowBalance"
                label="Escrow balance"
                placeholder="Current escrow balance"
              />
            </Card.Body>
            <Card.Body>
              <NumberInput
                label="Principal payment"
                required
                placeholder="Principal payment"
                id="principal"
                control={control}
                name="principal"
              />
              <NumberInput
                label="Interest payment"
                required
                placeholder="Interest payment"
                id="interest"
                control={control}
                name="interest"
              />
              <NumberInput
                label="Escrow payment"
                required
                placeholder="Escrow payment"
                id="escrow"
                control={control}
                name="escrow"
              />
              <TextField
                control={control}
                name="insuranceEffectiveDate"
                type="date"
                label="Current insurance effective date"
              />
            </Card.Body>
            <Card.Footer>
              <Button icon={TbPlus} type="submit">
                Create
              </Button>
            </Card.Footer>
          </Card>
        </form>
      </Container>
    </AppPage>
  );
};
